var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{attrs:{"data-testid":"color"}},[_c('Box',{attrs:{"backgroundColor":_vm.token.value,"border":"none"}}),_c('TextElement',{attrs:{"isAlternative":"true"}},[_vm._v(_vm._s(_vm.token.value))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }